export enum ErrorType {
  IMPORT_DUPLICATE = 'duplicate',
  EXISTS = 'exists',
  MANDATORY = 'mandatory',
  IDENTIFIER = 'identifier',
  FORMAT = 'format',
}

/**
 * Custom Error Types for logging to New Relic
 */
export enum CustomError {
  ACCOUNT_CREATION_FAILED = 'account-creation-failed',
  USER_CREATION_FAILED = 'user-creation-failed',
  ENTITY_UPDATE = 'entity-update',
  ENTITY_BULK_UPDATE = 'entity-bulk-update',
  ENTITY_CUSTOM_FIELD_UPDATE = 'entity-custom-field-update',
  MODEL_ITEM_MERGE = 'model-item-merge',
  MODEL_ITEM_UPDATE = 'model-item-update',
  REACT_ERROR_BOUNDARY = 'react-error-boundary',
  FETCH_CLIENT_UNKNOWN_SERVER_200_ERROR = 'fetch-client-unknown-server-200-error',
  FETCH_CLIENT_REFRESH_TOKEN_FAILURE = 'fetch-client-refresh-token-failure',
  FETCH_CLIENT_REFRESH_TOKEN_WAIT_TIMEOUT = 'fetch-client-refresh-token-wait-timeout',
  FETCH_CLIENT_CASE_UNHANDLED = 'fetch-client-case-unhandled',
  FETCH_CLIENT_UNKNOWN_ERROR = 'fetch-client-unknown-error',
  FETCH_CLIENT_NETWORK_ERROR = 'fetch-client-504-server-error',
  FETCH_CLIENT_DATA_TRANSFORM_FAILURE = 'fetch-client-data-transform-failure',
  FETCH_CLIENT_JSON_PARSE_FAILURE = 'fetch-client-json-parse-failure',
  FETCH_CLIENT_400_BAD_REQUEST_ERROR = 'fetch-client-400-bad-request-error',
  FETCH_CLIENT_401_UNAUTHORIZED_ERROR = 'fetch-client-401-unauthorized-error',
  FETCH_CLIENT_REQUEST_BLOCKED_BY_COOLDOWN = 'fetch-client-request-blocked-by-cooldown',
  FETCH_CLIENT_WAIT_FOR_REQUEST_CACHE_TIMEOUT = 'fetch-client-wait-for-request-cache_timeoout',
  FETCH_CLIENT_SERVER_ERROR = 'fetch-client-server-error',
  UNKNOWN_GRAPHQL_FETCH_ERROR = 'unknown-graphql-fetch-error',
  GET_DOWNLOAD_URL = 'get-download-url',
  GET_UPLOAD_URL = 'get-upload-url',
  CONTACT_WITHOUT_COMPANY = 'contact-without-company',
  OAUTH_TEAMS_LOGIN = 'oauth-teams-login',
  AUTHENTICATE_OFFICE_365_ERROR = 'authenticate-office-365-error',
  CHART_NO_COLUMN_DATA = 'chart-no-column-data',
  AUTHENTICATED_DATA_LOADING_RETRIES_EXCEEDED = 'authenticated-data-loading-retries-exceeded',
  AUTHENTICATED_DATA_LOADING_FAILURE = 'authenticated-data-loading-failure',
}
